export default __webpack_public_path__ + "static/media/free_delivery.44a0b743.svg";